import Vue from 'vue'
import Router from 'vue-router'
import AuthLayout from '../components/auth/AuthLayout'
import AppLayout from '../components/admin/AppLayout'

Vue.use(Router)

const EmptyParentComponent = {
  template: '<router-view></router-view>',
}

const demoRoutes = []
if (
  process.env.NODE_ENV === 'development' ||
  process.env.VUE_APP_INCLUDE_DEMOS
) {
  const vueBookRoutes = require('./vueBookRoutes').default
  vueBookRoutes.forEach(route => demoRoutes.push(route))
}

export default new Router({
  // mode: process.env.VUE_APP_ROUTER_MODE_HISTORY === 'true' ? 'history' : 'hash',
  mode: 'hash',
  routes: [
    ...demoRoutes,
    {
      path: '*',
      redirect: '/auth/login',
    },
    {
      path: '/',
      redirect: '/admin/dashboard',
    },
    {
      path: '/auth',
      component: AuthLayout,
      children: [
        {
          name: 'login',
          path: 'login',
          component: () => import('../components/auth/login/Login.vue'),
          meta: {
            requireAuthentication: false,
            resource: 'Login'
          },
        },
        {
          name: 'signup',
          path: 'signup',
          component: () => import('../components/auth/signup/Signup.vue'),
        },
        {
          name: 'recover-password',
          path: 'recover-password',
          component: () =>
            import('../components/auth/recover-password/RecoverPassword.vue'),
        },
        {
          path: '',
          redirect: { name: 'login' },
        },
      ],
    },
    {
      path: '/404',
      component: EmptyParentComponent,
      children: [
        {
          name: 'not-found-advanced',
          path: 'not-found-advanced',
          component: () =>
            import('../components/pages/404-pages/VaPageNotFoundSearch.vue'),
        },
        {
          name: 'not-found-simple',
          path: 'not-found-simple',
          component: () =>
            import('../components/pages/404-pages/VaPageNotFoundSimple.vue'),
        },
        {
          name: 'not-found-custom',
          path: 'not-found-custom',
          component: () =>
            import('../components/pages/404-pages/VaPageNotFoundCustom.vue'),
        },
        {
          name: 'not-found-large-text',
          path: '/pages/not-found-large-text',
          component: () =>
            import('../components/pages/404-pages/VaPageNotFoundLargeText.vue'),
        },
      ],
    },
    {
      name: 'Admin',
      path: '/admin',
      component: AppLayout,
      children: [
        {
          name: 'dashboard',
          path: 'dashboard',
          component: () => import('../components/dashboard/Dashboard.vue'),
          default: true,
          meta: {
            requireAuthentication: true,
            resource: 'Dashboard'
          }
        },
        {
          name: 'companies',
          path: 'companies',
          component: () => import('../components/companies/Company.vue'),
          meta: {
            requireAuthentication: true,
            resource: 'Companies'
          }
        },

        {
          name: 'layer-picker',
          path: 'layer-picker',
          component: () => import('../components/products/LayerPicker.vue'),
          meta: {
            requireAuthentication: true,
            resource: "LayerPicker"
          }
        },

        {
          name: 'import-orders',
          path: 'import-orders',
          component: () => import('../components/orders/ImportOrders.vue'),
          meta: {
            requireAuthentication: true,
            resource: 'Loads'
          }
        },

        {
          name: 'import-loads',
          path: 'import-loads',
          component: () => import('../components/loads/ImportLoads.vue'),
            meta: {
            requireAuthentication: true,
            resource: 'Loads'
          }
        },

        {
          name: 'import-control',
          path: 'import-control',
          component: () => import('../components/loads/ImportControl.vue'),
          meta: {
            requireAuthentication: true,
            resource: 'Loads'
          }
        },

        {
          name: 'import-heineken',
          path: 'import-heineken',
          component: () => import('../components/loads/ImportHeineken.vue'),
          meta: {
            requireAuthentication: true,
            resource: 'Loads'
          }
        },

        {
          name: 'import-solar-txt',
          path: 'import-solar-txt',
          component: () => import('../components/loads/ImportSolarLoadsTxt.vue'),
          meta: {
            requireAuthentication: true,
            resource: 'Loads'
          }
        },

        {
          name: 'import-products-control',
          path: 'import-products-control',
          component: () => import('../components/products/ImportControlProducts.vue'),
          meta: {
            requireAuthentication: true,
            resource: 'Products'
          }
        },

        {
          name: 'import-vehicles',
          path: 'import-vehicles',
          component: () => import('../components/vehicles/ImportVehicles.vue'),
          meta: {
            requireAuthentication: true,
            resource: "Vehicles"
          }
        },

        {
          name: 'import-vehicle-types',
          path: 'import-vehicles-types',
          component: () => import('../components/vehicle_types/ImportVehicleTypes.vue'),
          meta: {
            requireAuthentication: true,
            resource: "Vehicles"
          }
        },

         {
          name: 'import-products',
          path: 'import-products',
          component: () => import('../components/products/ImportProducts.vue'),
          meta: {
            requireAuthentication: true,
            resource: "Products"
          }
        },

        {
          name: 'import-product-groups',
          path: 'import-product-groups',
          component: () => import('../components/product_groups/ImportProductGroups.vue'),
          meta: {
            requireAuthentication: true,
            resource: "Products"
          }
        },

        {
          name: 'import-clients',
          path: 'import-clients',
          component: () => import('../components/clients/ImportClients.vue'),
          meta: {
            requireAuthentication: true,
            resource: "Clients"
          }
        },

         {
          name: 'import-localities',
          path: 'import-localities',
          component: () => import('../components/localities/ImportLocalities.vue'),
          meta: {
            requireAuthentication: true,
            resource: 'Localities'
          }
        },

        {
          name: 'import-sequence-products',
          path: 'import-sequence-products',
          component: () => import('../components/products/ImportSequenceProducts.vue'),
          meta: {
            requireAuthentication: true,
            resource: "Products"
          }
        },

        {
          name: 'import-users',
          path: 'import-users',
          component: () => import('../components/products/ImportUsers.vue'),
          meta: {
            requireAuthentication: true,
            resource: "Users"
          }
        },

        {
          name: 'import-ignored-products',
          path: 'import-ignored-products',
          component: () => import('../components/products/ImportIgnoredProducts.vue'),
          meta: {
            requireAuthentication: true,
            resource: "Products"
          }
        },

        {
          name: 'import-unit-products',
          path: 'import-unit-products',
          component: () => import('../components/products/ImportUnitProducts.vue'),
          meta: {
            requireAuthentication: true,
            resource: "Products"
          }
        },

        {
          name: 'import-pallet-products',
          path: 'import-pallet-products',
          component: () => import('../components/products/ImportPalletProducts.vue'),
          meta: {
            requireAuthentication: true,
            resource: "Products"
          }
        },

        {
          name: 'ignored-products',
          path: 'ignored-products',
          component: () => import('../components/products/IgnoredProducts.vue'),
          meta: {
            requireAuthentication: true,
            resource: 'Products',
          },
        },

        {
          name: 'unit-products',
          path: 'unit-products',
          component: () => import('../components/products/UnitProducts.vue'),
          meta: {
            requireAuthentication: true,
            resource: 'Products',
          },
        },

        {
          name: 'statistics',
          path: 'statistics',
          component: EmptyParentComponent,
          children: [
            {
              name: 'charts',
              path: 'charts',
              component: () =>
                import('../components/statistics/charts/Charts.vue'),
              meta: {
                wikiLink:
                  'https://github.com/epicmaxco/vuestic-admin/wiki/Charts',
              },
            },
            {
              name: 'progress-bars',
              path: 'progress-bars',
              component: () =>
                import(
                  '../components/statistics/progress-bars/ProgressBars.vue'
                ),
              meta: {
                wikiLink:
                  'https://github.com/epicmaxco/vuestic-admin/wiki/Progress-Bars',
              },
            },
          ],
        },
        {
          name: 'forms',
          path: 'forms',
          component: EmptyParentComponent,
          children: [
            {
              name: 'form-elements',
              path: 'form-elements',
              component: () =>
                import('../components/forms/form-elements/FormElements.vue'),
              meta: {
                wikiLink:
                  'https://github.com/epicmaxco/vuestic-admin/wiki/inputs',
              },
            },
            {
              name: 'medium-editor',
              path: 'medium-editor',
              component: () =>
                import('../components/forms/medium-editor/MediumEditor.vue'),
              meta: {
                wikiLink:
                  'https://github.com/epicmaxco/vuestic-admin/wiki/Medium-Editor',
              },
            },
            {
              name: 'form-loads',
              path: 'form-loads',
              component: () =>
                import('../components/forms/form-elements/FormLoads.vue'),
            },
            {
              name: 'form-mounting-order',
              path: 'form-mounting-order',
              component: () =>
                import('../components/forms/form-elements/FormMountingOrder.vue'),
            },
            {
              name: 'form-mounting-flow',
              path: 'form-mounting-flow',
              component: () =>
                import('../components/forms/form-elements/FormMountingFlow.vue'),
            },
            {
              name: 'form-load-flow',
              path: 'form-load-flow',
              component: () =>
                import('../components/forms/form-elements/FormLoadFlow.vue'),
            },
            {
              name: 'form-sequence-load',
              path: 'form-sequence-load',
              component: () =>
                import('../components/forms/form-elements/FormSequenceLoad.vue'),
            },
            {
              name: 'form-load-products',
              path: 'form-load-products/:loadId',
              component: () =>
                import('../components/forms/form-elements/FormLoadProducts.vue'),
            },
            {
              name: 'form-vehicle-bays',
              path: 'form-vehicle-bays/:id',
              component: () =>
                import('../components/forms/form-elements/FormVehicleBays.vue'),
            },
            {
              name: 'form-product-packages',
              path: 'form-product-packages/:id',
              component: () =>
                import('../components/forms/form-elements/FormProductPackages.vue'),
            },
            {
              name: 'form-compatibilities',
              path: 'form-compatibilities/:id',
              component: () =>
                import('../components/forms/form-elements/FormCompatibilities.vue'),
            },
            {
              name: 'form-clients',
              path: 'form-clients',
              component: () =>
                import('../components/forms/form-elements/FormClients.vue'),
                meta: {
                  requireAuthentication: true,
                  resource: 'Clients',
                }
            },
            {
              name: 'form-localities',
              path: 'form-localities',
              component: () => import('../components/forms/form-elements/FormLocalities.vue'),
              meta: {
                requireAuthentication: true,
                resource: 'Localities',
              }
            },
            {
              name: 'form-setup',
              path: 'form-setup',
              component: () => import('../components/forms/form-elements/FormSetup.vue'),
              meta: {
                requireAuthentication: true,
                resource: 'SetupMenu',
              }
            },
            {
              name: 'form-general-setup',
              path: 'form-general-setup',
              component: () => import('../components/forms/form-elements/FormGeneralSetups.vue'),
              meta: {
                requireAuthentication: true,
                resource: 'SetupMenu',
              },
            },
            {
              name: 'form-packages',
              path: 'form-packages',
              component: () =>
                import('../components/forms/form-elements/FormPackages.vue'),
            },
            {
              name: 'form-pallets',
              path: 'form-pallets',
              component: () =>
                import('../components/forms/form-elements/FormPallets.vue'),
            },
            {
              name: 'form-fragilities',
              path: 'form-fragilities',
              component: () =>
                import('../components/forms/form-elements/FormFragilities.vue'),
            },
            {
              name: 'form-product-line',
              path: 'form-product-line',
              component: () =>
                import('../components/forms/form-elements/FormProductLine.vue'),
            },
            {
              name: 'form-product-family',
              path: 'form-product-family',
              component: () =>
                import('../components/forms/form-elements/FormProductFamily.vue'),
            },
            {
              name: 'form-product-group',
              path: 'form-product-group',
              component: () =>
                import('../components/forms/form-elements/FormProductGroup.vue'),
            },
            {
              name: 'form-roles',
              path: 'form-roles',
              component: () =>
                import('../components/forms/form-elements/FormRoles.vue'),
            },
            {
              name: 'form-users',
              path: 'form-users',
              component: () =>
                import('../components/forms/form-elements/FormUsers.vue'),
            },
            {
              name: 'form-role-user',
              path: 'form-role-user',
              component: () =>
                import('../components/forms/form-elements/FormRoleUser.vue'),
            },
            {
              name: 'form-user-locality',
              path: 'form-user-locality',
              component: () =>
                import('../components/forms/form-elements/FormUserLocality.vue'),
            },
            {
              name: 'form-pallet-user',
              path: 'form-pallet-user',
              component: () =>
                import('../components/forms/form-elements/FormPalletUser.vue'),
            },
            {
              name: 'form-vehicle',
              path: 'form-vehicle',
              component: () =>
                import('../components/forms/form-elements/FormVehicle.vue'),
            },
            {
              name: 'form-vehicle-types',
              path: 'form-vehicle-types',
              component: () =>
                import('../components/forms/form-elements/FormVehicleTypes.vue'),
            },
            {
              name: 'form-bay-types',
              path: 'form-bay-types',
              component: () =>
                import('../components/forms/form-elements/FormBayTypes.vue'),
            },
            {
              name: 'form-product-criticalities',
              path: 'form-product-criticalities',
              component: () =>
                import('../components/forms/form-elements/FormProductCriticalities.vue'),
            },
            {
              name: 'form-products',
              path: 'form-products',
              component: () =>
                import('../components/forms/form-elements/FormProducts.vue'),
            },
            {
              name: 'show-product',
              path: 'show-product',
              component: () =>
                import('../components/forms/form-elements/ShowProduct.vue'),
            },
            {
              name: 'show-detailing',
              path: 'show-detailing',
              component: () =>
                import('../components/forms/form-elements/ShowDetailing.vue'),
            },
            {
              name: 'show-vehicle-type',
              path: 'show-vehicle-type',
              component: () =>
                import('../components/forms/form-elements/ShowVehicleType.vue'),
            },
            {
              name: 'show-package',
              path: 'show-package',
              component: () =>
                import('../components/forms/form-elements/ShowPackage.vue'),
            },
            {
              name: 'form-product-sequence',
              path: 'form-product-sequence',
              component: () =>
                import('../components/forms/form-elements/FormProductSequence.vue'),
            },
            {
              name: 'form-pallet-type-setup',
              path: 'form-pallet-type-setup',
              component: () =>
                import('../components/forms/form-elements/FormPalletTypeSetup.vue'),
            },
            {
              name: 'form-pallet-products',
              path: 'form-pallet-products/:id',
              component: () =>
                import('../components/forms/form-elements/FormPalletProducts.vue'),
            },
            {
              name: 'form-locality-emails',
              path: 'form-locality-emails/:id',
              component: () =>
                import('../components/forms/form-elements/FormLocalityEmails.vue'),
            },
          ],
        },
        {
          name: 'tables',
          path: 'tables',
          component: EmptyParentComponent,
          children: [
            {
              name: 'queues',
              path: 'queues',
              component: () => import('../components/orders/Queues.vue')
            },
            {
              name: 'order-history',
              path: 'order-history',
              component: () => import('../components/orders/OrderHistory.vue')
            },
            {
              name: 'load-history',
              path: 'load-history',
              component: () => import('../components/loads/LoadHistory.vue')
            },

            {
              name: 'markup',
              path: 'markup',
              component: () =>
                import('../components/markup-tables/MarkupTables.vue'),
              wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Tables', // TODO Update docs
            },
            {
              name: 'data',
              path: 'data',
              component: () =>
                import('../components/data-tables/DataTables.vue'),
              wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Tables', // TODO Add docs
            },
            {
              name: 'vehicles',
              path: 'vehicles',
              component: () =>
                import('../components/data-tables/scenarios/VehicleTable.vue'),
              meta: {
                requireAuthentication: true,
                resource: "Vehicles"
              }
            },

            {
              name: 'vehicle_types',
              path: 'vehicle_types',
              component: () =>
                import('../components/data-tables/scenarios/VehicleTypesTable.vue'),
              meta: {
                requireAuthentication: true,
                resource: "VehicleTypes"
              }
            },
            {
              name: 'lists-load-table',
              path: 'lists-load-table/',
              component: () =>
                import('../components/data-tables/scenarios/ListsLoadTable.vue'),
            },
            {
              name: 'order-errors',
              path: 'order-errors',
              component: () => import('../components/data-tables/scenarios/OrderErrors.vue')
            },
            {
              name: 'list-order-products',
              path: 'list-order-products',
              component: () =>
                import('../components/data-tables/scenarios/ListOrderProductsTable.vue'),
            },
            {
              name: 'list-sorted-order-products',
              path: 'list-sorted-order-products',
              component: () =>
                import('../components/data-tables/scenarios/ListSortedOrderProductsTable.vue'),
            },
            {
              name: 'list-order-histories',
              path: 'list-order-histories/',
              component: () =>
                import('../components/data-tables/scenarios/ListOrderHistories.vue'),
            },
            {
              name: 'data-table-load-products',
              path: 'data-table-load-products/',
              component: () =>
                import('../components/data-tables/scenarios/DataTableLoadProducts.vue'),
            },
            {
              name: 'data-table-load-divergences',
              path: 'data-table-load-divergences/',
              component: () =>
                import('../components/data-tables/scenarios/DataTableLoadDivergences.vue'),
            },
            {
              name: 'bay_types',
              path: 'bay_types',
              component: () =>
                import('../components/data-tables/scenarios/BayTypesTable.vue'),
              meta: {
                requireAuthentication: true,
                resource: "BayTypes"
              }
            },
            {
              name: 'products',
              path: 'products',
              component: () =>
                import('../components/data-tables/scenarios/ProductTable.vue'),
              meta: {
                requireAuthentication: true,
                resource: "Products"
              }
            },

            {
              name: 'packages',
              path: 'packages',
              component: () =>
                import('../components/data-tables/scenarios/PackageTable.vue'),
              meta: {
                requireAuthentication: true,
                resource: "Packages"
              }
            },
            {
              name: 'pallets',
              path: 'pallets',
              component: () =>
                import('../components/data-tables/scenarios/PalletsTable.vue'),
              meta: {
                requireAuthentication: true,
                resource: "Pallets"
              }
            },
            {
              name: 'files',
              path: 'files',
              component: () =>
                import('../components/data-tables/scenarios/FilesTable.vue'),
              meta: {
                requireAuthentication: true,
                resource: "SetupMenu"
              }
            },
            {
              name: 'product-lines',
              path: 'product-lines',
              component: () =>
                import('../components/data-tables/scenarios/ProductLinesTable.vue'),
              meta: {
                requireAuthentication: true,
                resource: "ProductLines"
              }
            },
            {
              name: 'product-families',
              path: 'product-families',
              component: () =>
                import('../components/data-tables/scenarios/ProductFamilyTable.vue'),
              meta: {
                requireAuthentication: true,
                resource: "ProductFamilies"
              }
            },
            {
              name: 'product-groups',
              path: 'product-groups',
              component: () =>
                import('../components/data-tables/scenarios/ProductGroupTable.vue'),
              meta: {
                requireAuthentication: true,
                resource: "ProductFamilies"
              }
            },
            {
              name: 'fragilities',
              path: 'fragilities',
              component: () =>
                import(
                  '../components/data-tables/scenarios/FragilityTable.vue'
                ),
                meta: {
                  requireAuthentication: true,
                  resource: "Fragilities"
                }
            },
            {
              name: 'quarantine',
              path: 'quarantine',
              component: () =>
                import(
                  '../components/data-tables/scenarios/QuarantineTable.vue'
                ),
                meta: {
                  requireAuthentication: true,
                  resource: "Quarantine"
                }
            },
            {
              name: 'clients',
              path: 'clients',
              component: () =>
                import('../components/data-tables/scenarios/ClientTable.vue'),
              meta: {
                requireAuthentication: true,
                resource: "Clients"
              }
            },
            {
              name: 'localities',
              path: 'localities',
              component: () => import('../components/data-tables/scenarios/LocalityTable.vue'),
              meta: {
                requireAuthentication: true,
                resource: 'Localities'
              }
            },
            {
              name: 'product_criticalities',
              path: 'product_criticalities',
              component: () =>
                import(
                  '../components/data-tables/scenarios/ProductCriticalityTable.vue'
                ),
            },
            {
              name: 'users',
              path: 'users',
              component: () =>
                import('../components/data-tables/scenarios/UserTable.vue'),
              meta: {
                requireAuthentication: true,
                resource: "Users"
              }
            },
            {
              name: 'roles',
              path: 'roles',
              component: () =>
                import('../components/data-tables/scenarios/RoleTable.vue'),
              meta: {
                requireAuthentication: true,
                resource: "Roles"
              }
            },
            {
              name: 'statuses',
              path: 'statuses',
              component: () =>
                import('../components/data-tables/scenarios/StatusTable.vue'),
              meta: {
                requireAuthentication: true,
                resource: "Statuses"
              }
            },
            {
              name: 'mounting-flow',
              path: 'mounting-flow',
              component: () =>
                import(
                  '../components/data-tables/scenarios/MountingFlowTable.vue'
                ),
              meta: {
                requireAuthentication: true,
                resource: "OrderSteps"
              }
            },
            {
              name: 'setup-initial',
              path: 'setup-initial',
              component: () =>
                import(
                  '../components/data-tables/scenarios/SetupInitial.vue'
                ),
              meta: {
                requireAuthentication: true,
                resource: "SetupMenu"
              }
            },
            {
              name: 'general-setup',
              path: 'general-setup',
              component: () =>
                import(
                  '../components/data-tables/scenarios/GeneralSetupsTable.vue'
                ),
              meta: {
                requireAuthentication: true,
                resource: "SetupMenu",
              }
            },
            {
              name: 'load-flow',
              path: 'load-flow',
              component: () =>
                import(
                  '../components/data-tables/scenarios/LoadFlowTable.vue'
                ),
              meta: {
                requireAuthentication: true,
                resource: "LoadSteps"
              }
            },
            {
              name: 'permissions',
              path: 'permissions',
              component: () =>
                import(
                  '../components/data-tables/scenarios/PermissionsTable.vue'
                ),
              meta: {
                requireAuthentication: true,
                resource: "RolePermissions"
              }
            },

            {
              name: 'loads',
              path: 'loads',
              component: () =>
                import('../components/data-tables/scenarios/LoadTable.vue'),
              meta: {
                requireAuthentication: true,
                resource: "Loads"
              }
            },

            {
              name: 'load_palletizing',
              path: 'load_palletizing',
              component: () =>
                import(
                  '../components/data-tables/scenarios/LoadPalletizingTable.vue'
                ),
              meta: {
                requireAuthentication: true,
                resource: 'LoadPalletizing'
              }
            },
            {
              name: 'crossdocking',
              path: 'crossdocking',
              component: () =>
                import(
                  '../components/data-tables/scenarios/CrossdockingTable.vue'
                ),
            },
            {
              name: 'load_sequence',
              path: 'load_sequence',
              component: () =>
                import(
                  '../components/data-tables/scenarios/LoadSequenceTable.vue'
                ),
              meta: {
                requireAuthentication: true,
                resource: "LoadSequence"
              }
            },
            {
              name: 'load_audits',
              path: 'load_audits',
              component: () =>
                import(
                  '../components/audits/LoadAudits.vue'
                ),
              meta: {
                requireAuthentication: true,
                resource: "LoadAudits"
              }
            },
            {
              name: 'order_step_audits',
              path: 'order_step_audits',
              component: () =>
                import(
                  '../components/audits/OrderStepAudits.vue'
                ),
              meta: {
                requireAuthentication: true,
                resource: "LoadAudits"
              }
            },
            {
              name: 'product_audits',
              path: 'product_audits',
              component: () =>
                import(
                  '../components/audits/ProductAudits.vue'
                ),
              meta: {
                requireAuthentication: true,
                resource: "LoadAudits"
              }
            },
            {
              name: 'user_audits',
              path: 'user_audits',
              component: () =>
                import(
                  '../components/audits/UserAudits.vue'
                ),
              meta: {
                requireAuthentication: true,
                resource: "LoadAudits"
              }
            },
            {
              name: 'product_sequence',
              path: 'product_sequence',
              component: () =>
                import(
                  '../components/data-tables/scenarios/ProductSequenceTable.vue'
                ),
                meta: {
                  requireAuthentication: true,
                  resource: "ProductSequence"
                }
            },
            {
              name: 'deliveries',
              path: 'deliveries',
              component: () => import('../components/data-tables/scenarios/LoadDeliveriesTable.vue'),
              meta: {
                requireAuthentication: true,
                resource: "Deliveries"
              }
            },
            {
              name: 'loads_finished',
              path: 'loads_finished',
              component: () => import('../components/data-tables/scenarios/LoadsFinishedTable.vue'),
              meta: {
                requireAuthentication: true,
                resource: "LoadsFinished"
              }
            },
            {
              name: 'load_deliveries',
              path: 'load_deliveries/:loadID',
              component: () => import('../components/data-tables/scenarios/DeliveriesTable.vue'),
            },
            {
              name: 'load_checks',
              path: 'load_checks',
              component: () => import('../components/data-tables/scenarios/LoadChecksTable.vue'),
              meta: {
                resource: "LoadChecks"
              }
            },
            {
              name: 'works',
              path: 'works',
              component: () =>
                import('../components/data-tables/scenarios/WorkTable.vue'),
              meta: {
                requireAuthentication: true,
                resource: "Works"
              }
            },
            {
              name: 'ranking',
              path: 'ranking',
              component: () =>
                import('../components/indicators/Ranking.vue'),
              meta: {
                requireAuthentication: true,
                resource: "Ranking"
              }
            },
            {
              name: 'products_by_boxes',
              path: 'products_by_boxes',
              component: () =>
                import('../components/indicators/ProductsByBoxes.vue'),
              meta: {
                // requireAuthentication: true,
                resource: "ProductsByBoxes"
              }
            },
            {
              name: 'products_by_pallets',
              path: 'products_by_pallets',
              component: () =>
                import('../components/indicators/ProductsByPallets.vue'),
              meta: {
                // requireAuthentication: true,
                resource: "ProductsByPallets"
              }
            },
            {
              name: 'daily_operations',
              path: 'daily_operations',
              component: () =>
                import('../components/daily_operations/DailyOperation.vue'),
            },
            {
              name: 'mounting_time',
              path: 'mounting_time',
              component: () =>
                import('../components/data-tables/scenarios/WorkTimeTable.vue'),
              meta: {
                requireAuthentication: true,
                resource: "MountingTime"
              }
            },
            {
              name: 'free_time',
              path: 'free_time',
              component: () =>
                import('../components/data-tables/scenarios/FreeTimeTable.vue'),
              meta: {
                requireAuthentication: true,
                resource: "FreeTime"
              }
            },
            {
              name: 'palletized_products',
              path: 'palletized_products/:loadID',
              component: () =>
                import(
                  '../components/data-tables/scenarios/PalletizedProductsTable.vue'
                ),
            },
            {
              name: 'vehicle_bays',
              path: 'vehicle_bays/:loadID',
              component: () =>
                import(
                  '../components/data-tables/scenarios/VehicleBaysTable.vue'
                ),
            },
            {
              name: 'vehicle_list_bays',
              path: 'vehicle_list_bays/:vehicleId',
              component: () =>
                import(
                  '../components/data-tables/scenarios/VehicleListBaysTable.vue'
                ),
            },
            {
              name: 'vehicle_bays_draggable',
              path: 'vehicle_bays_draggable/:loadID',
              component: () =>
                import(
                  '../components/data-tables/scenarios/VehicleBaysDraggable.vue'
                ),
            },
            {
              name: 'vehicle-bay-quarantine-draggable',
              path: 'vehicle-bay-quarantine-draggable',
              component: () =>
                import(
                  '../components/data-tables/scenarios/VehicleBayQuarantineDraggable.vue'
                ),
            },
            {
              name: 'sorted_products',
              path: 'sorted_products',
              component: () =>
                import(
                  '../components/data-tables/scenarios/SortedProducts.vue'
                ),
            },
            {
              name: 'palletized_products_by_load',
              path: 'palletized_products_by_load',
              component: () =>
                import(
                  '../components/data-tables/scenarios/PalletizedProducts.vue'
                ),
            },
            {
              name: 'agrouped_load_products_by_load',
              path: 'agrouped_load_products_by_load',
              component: () =>
                import(
                  '../components/data-tables/scenarios/DataTableAgroupedLoadProducts.vue'
                ),
            },
            {
              name: 'billed_products_by_load',
              path: 'billed_products_by_load',
              component: () =>
                import(
                  '../components/data-tables/scenarios/DataTableBilledProducts.vue'
                ),
            },
            {
              name: 'mounting',
              path: 'mounting',
              component: () =>
                import('../components/data-tables/scenarios/MountingOrdersTable.vue'),
              meta: {
                requireAuthentication: true,
                resource: "Mounting"
              }
            },

            {
              name: 'transporting',
              path: 'transporting',
              component: () =>
                import('../components/data-tables/scenarios/TransportingOrdersTable.vue'),
              meta: {
                requireAuthentication: true,
                resource: "Transporting"
              }
            },

            {
              name: 'vehicle_liberation',
              path: 'vehicle_liberation',
              component: () =>
                import('../components/data-tables/scenarios/VehicleLiberationOrdersTable.vue'),
              meta: {
                requireAuthentication: true,
                resource: "VehicleLiberation"
              }
            },

            {
              name: 'conference_supervision',
              path: 'conference_supervision',
              component: () =>
                import('../components/data-tables/scenarios/ConferenceSupervisionOrdersTable.vue'),
              meta: {
                requireAuthentication: true,
                resource: "ConferenceSupervision"
              }
            },

            {
              name: 'layer_picking',
              path: 'layer_picking',
              component: () =>
                import('../components/data-tables/scenarios/LayerPickingOrdersTable.vue'),
              meta: {
                requireAuthentication: true,
                resource: "LayerPicking"
              }
            },

            {
              name: 'stacking',
              path: 'stacking',
              component: () =>
                import('../components/data-tables/scenarios/StackingOrdersTable.vue'),
              meta: {
                requireAuthentication: true,
                resource: "Stacking"
              }
            },

            {
              name: 'finished',
              path: 'finished',
              component: () =>
                import('../components/data-tables/scenarios/FinishedOrdersTable.vue'),
              meta: {
                requireAuthentication: true,
                resource: "Finished"
              }
            },

            {
              name: 'conferencing',
              path: 'conferencing',
              component: () =>
                import('../components/data-tables/scenarios/ConferencingOrdersTable.vue'),
              meta: {
                requireAuthentication: true,
                resource: "Conferencing"
              }
            },

            {
              name: 'allorders',
              path: 'allorders',
              component: () =>
                import('../components/data-tables/scenarios/AllOrdersTable.vue'),
              meta: {
                requireAuthentication: true,
                resource: 'Finished',
              },
            },

            {
              name: 'data_integrations',
              path: 'data_integrations',
              component: () =>
                import(
                  '../components/data_reports/DataIntegrations.vue'
                ),
              meta: {
                requireAuthentication: true,
                resource: 'LoadAudits',
              },
            },

            {
              name: 'notifications',
              path: 'notifications',
              component: () =>
                import(
                  '../components/data_reports/Notifications.vue'
                ),
              meta: {
                requireAuthentication: true,
                resource: 'LoadAudits',
              },
            },

            {
              name: 'loads_by_data_integration',
              path: 'loads_by_data_integration',
              component: () =>
                import(
                  '../components/data_reports/LoadsByDataIntegration.vue'
                ),
              meta: {
              },
            },
            // {
            //   name: 'localities',
            //   path: 'localities',
            //   component: () => import('../components/data-tables/scenarios/LocalityTable.vue'),
            //   meta: {
            //     requireAuthentication: true,
            //     resource: 'Localities'
            //   }
            // },
          ],
        },
        {
          name: 'ui',
          path: 'ui',
          component: EmptyParentComponent,
          children: [
            {
              name: 'typography',
              path: 'typography',
              component: () =>
                import('../components/ui/typography/Typography.vue'),
            },
            {
              name: 'buttons',
              path: 'buttons',
              component: () => import('../components/ui/buttons/Buttons'),
              meta: {
                wikiLink:
                  'https://github.com/epicmaxco/vuestic-admin/wiki/Buttons',
              },
            },
            {
              name: 'rating',
              path: 'rating',
              component: () => import('../components/ui/rating/Rating'),
              meta: {
                wikiLink:
                  'https://github.com/epicmaxco/vuestic-admin/wiki/Rating',
              },
            },
            {
              name: 'color-pickers',
              path: 'color-pickers',
              component: () =>
                import('../components/ui/color-pickers/ColorPickers'),
              meta: {
                wikiLink:
                  'https://github.com/epicmaxco/vuestic-admin/wiki/Color-Pickers',
              },
            },
            {
              name: 'timelines',
              path: 'timelines',
              component: () => import('../components/ui/timelines/Timelines'),
              meta: {
                wikiLink:
                  'https://github.com/epicmaxco/vuestic-admin/wiki/Timelines',
              },
            },
            {
              name: 'notifications',
              path: 'notifications',
              component: () =>
                import('../components/ui/notifications/Notifications'),
              meta: {
                wikiLink:
                  'https://github.com/epicmaxco/vuestic-admin/wiki/Notifications',
              },
            },
            {
              path: 'icons',
              component: () => import('../components/ui/icons/Icons'),
              children: [
                {
                  name: 'icon-sets',
                  path: '', // Default route
                  component: () => import('../components/ui/icons/SetsList'),
                  meta: {
                    wikiLink:
                      'https://github.com/epicmaxco/vuestic-admin/wiki/Icons',
                  },
                },
                {
                  name: 'icon-set',
                  path: ':name',
                  component: () => import('../components/ui/icons/IconSet'),
                  props: true,
                  meta: {
                    wikiLink:
                      'https://github.com/epicmaxco/vuestic-admin/wiki/Icons',
                  },
                },
              ],
            },
            {
              name: 'spinners',
              path: 'spinners',
              component: () => import('../components/ui/spinners/Spinners'),
            },
            {
              name: 'grid',
              path: 'grid',
              component: () => import('../components/ui/grid/Grid'),
            },
            {
              name: 'modals',
              path: 'modals',
              component: () => import('../components/ui/modals/Modals'),
              meta: {
                wikiLink:
                  'https://github.com/epicmaxco/vuestic-admin/wiki/Modals',
              },
            },
            {
              name: 'cards',
              path: 'cards',
              component: () => import('../components/ui/cards/Cards'),
              meta: {
                wikiLink:
                  'https://github.com/epicmaxco/vuestic-admin/wiki/Cards',
              },
            },
            {
              name: 'file-upload',
              path: 'file-upload',
              component: () =>
                import('../components/ui/file-upload/FileUpload'),
              meta: {
                wikiLink:
                  'https://github.com/epicmaxco/vuestic-admin/wiki/File-Upload',
              },
            },
            {
              name: 'chips',
              path: 'chips',
              component: () => import('../components/ui/chips/Chips'),
              meta: {
                wikiLink:
                  'https://github.com/epicmaxco/vuestic-admin/wiki/Chips',
              },
            },
            {
              name: 'tree-view',
              path: 'tree-view',
              component: () => import('../components/ui/tree-view/TreeView'),
              meta: {
                wikiLink:
                  'https://github.com/epicmaxco/vuestic-admin/wiki/Tree-view',
              },
            },
            {
              name: 'collapses',
              path: 'collapses',
              meta: {
                wikiLink:
                  'https://github.com/epicmaxco/vuestic-admin/wiki/Collapse',
              },
              component: () => import('../components/ui/collapse/Collapses'),
            },
            {
              name: 'colors',
              path: 'colors',
              component: () => import('../components/ui/colors/Colors'),
            },
            {
              name: 'spacing',
              path: 'spacing',
              component: () => import('../components/ui/spacing/Spacing'),
            },
            {
              name: 'sliders',
              path: 'sliders',
              component: () => import('../components/ui/sliders/Sliders'),
              meta: {
                wikiLink:
                  'https://github.com/epicmaxco/vuestic-admin/wiki/Sliders',
              },
            },
            {
              name: 'popovers',
              path: 'popovers',
              component: () => import('../components/ui/popovers/Popovers'),
            },
            {
              name: 'chat',
              path: 'chatPage',
              component: () => import('../components/ui/chat/ChatPage'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Chat',
              },
            },
            {
              name: 'tabs',
              path: 'tabs',
              component: () => import('../components/ui/tabs/Tabs'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Tabs',
              },
            },
            {
              name: 'lists',
              path: 'lists',
              component: () => import('../components/lists/Lists.vue'),
              meta: {
                wikiLink:
                  'https://github.com/epicmaxco/vuestic-admin/wiki/Lists',
              },
            },
          ],
        },
        {
          name: 'maps',
          path: 'maps',
          component: EmptyParentComponent,
          children: [
            {
              name: 'google-maps',
              path: 'google-maps',
              component: () =>
                import('../components/maps/google-maps/GoogleMapsPage'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Maps',
              },
            },
            {
              name: 'yandex-maps',
              path: 'yandex-maps',
              component: () =>
                import('../components/maps/yandex-maps/YandexMapsPage'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Maps',
              },
            },
            {
              name: 'leaflet-maps',
              path: 'leaflet-maps',
              component: () =>
                import('../components/maps/leaflet-maps/LeafletMapsPage'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Maps',
              },
            },
            {
              name: 'bubble-maps',
              path: 'bubble-maps',
              component: () =>
                import('../components/maps/bubble-maps/BubbleMapsPage'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Maps',
              },
            },
            {
              name: 'line-maps',
              path: 'line-maps',
              component: () =>
                import('../components/maps/line-maps/LineMapsPage'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Maps',
              },
            },
          ],
        },
        {
          name: 'pages',
          path: 'pages',
          component: EmptyParentComponent,
          children: [
            {
              name: '404-pages',
              path: '404-pages',
              component: () =>
                import('../components/pages/404-pages/404PagesPage'),
            },
          ],
        },
      ],
    },
  ],
})
